import type {Router} from 'vue-router'
import {pageMetaStore} from '@/stores/pageMetaStore'


import { createI18n } from 'vue-i18n'
import * as en from '@/lang/en.json'

const i18n = createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        'en': en
    },
})

export function configureRouter(router: Router, app: any) {
    router.beforeEach(async (to, from, next) => {
        const pagemeta = pageMetaStore()

        const title = typeof to.meta.title === 'string' ? i18n.global.t(to.meta.title) : to.meta.title
        const description = typeof to.meta.description === 'string' ? i18n.global.t(to.meta.description) : to.meta.description

        pagemeta.setPageMeta({
            title: title,
            description: description
        })

        next()
    })
}
